import { useState, useCallback } from 'react';
import * as wmteamManagementAction from "../redux/store-sarang/wmteam/wmteam-management.store";

export const useLookupWMTeam = () => {
    const [wMTeam, setWMTeam] = useState([]);

    const getLookupWMTeam = useCallback(async () => {
        try {
            const res = await wmteamManagementAction.GetLookupWMTeam();
            if (res && res.content) {
                setWMTeam(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { wMTeam, getLookupWMTeam };
};
